import React from "react";
import * as Utils from "../utils";

const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M8 7V5a1 1 0 011-1h6a1 1 0 011 1v2" />
  </svg>
);

function RichiesteDettaglio({ richiesta, onClose, onAnnullaRequest }) {
  return (
    <div style={{ height: "calc(100dvh - 3.5rem - env(safe-area-inset-top))", overflowY: "auto", paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-lg w-full mx-auto mt-4">
        <h2 className="text-xl font-bold mb-6 text-blu-uss text-center">
          Dettaglio Richiesta
        </h2>
        <div className="mb-2">
          <strong className="text-blu-uss">Data richiesta:</strong>{" "}
          <span className="text-black">
            {Utils.formatItalianDate(richiesta.data_richiesta, true)}
          </span>
        </div>
        <div className="mb-2">
          <strong className="text-blu-uss">Tipo:</strong>{" "}
          <span className="text-black">{richiesta.tipologia}</span>
        </div>
        <div className="mb-2">
          <strong className="text-blu-uss">Periodo:</strong>{" "}
          <span className="text-black">
            {Utils.formatItalianDate(richiesta.dal)} -{" "}
            {Utils.formatItalianDate(richiesta.al)}
          </span>
        </div>
        {richiesta.unita_di_misura && (
          <div className="mb-2">
            <strong className="text-blu-uss">{richiesta.unita_di_misura}:</strong>{" "}
            <span className="text-black">{richiesta.valore}</span>
          </div>
        )}
        <div className="mb-2">
          <strong className="text-blu-uss">Note:</strong>{" "}
          <span className="text-black">{richiesta.note || "-"}</span>
        </div>
        <div className="mb-2">
          <strong className="text-blu-uss">Stato:</strong>{" "}
          <span className="text-black">{richiesta.stato_richiesta}</span>
        </div>
        <div className="mb-2">
          <strong className="text-blu-uss">Confermato da:</strong>{" "}
          <span className="text-black">{richiesta.user_conferma || "-"}</span>
        </div>
        <div className="mb-2">
          <strong className="text-blu-uss">Data conferma:</strong>{" "}
          <span className="text-black">
            {richiesta.data_conferma
              ? Utils.formatItalianDate(richiesta.data_conferma, true)
              : "-"}
          </span>
        </div>
        <div className="mt-8 flex justify-start">
          <button
            onClick={onAnnullaRequest}
            className="p-2 text-red-400 hover:text-red-600 transition rounded-lg"
            title="Elimina richiesta"
          >
            <TrashIcon />
          </button>
        </div>
      </div>
    </div>
  );
}

export default RichiesteDettaglio;
